// @flow

import React, { type Node } from 'react';

import { ContextProvider } from './context-provider';

import { type LookAndFeelRootPropsConfirmedPayment } from '@tectonics/look-and-feel';
import { StatusMessage } from './status-message';
import { ExchangeRate } from '../commons/exchange-rate/components';
import { IofDisplay } from '../commons/iof/components';
import { SelectedInstalmentDisplay } from '../commons/instalments/components';
import { TotalAmountOverride } from '../commons/total-amount/components';

export function ConfirmedPaymentPage(props: LookAndFeelRootPropsConfirmedPayment): Node {
  return (
    <ContextProvider {...props}>
      <StatusMessage />
      <ExchangeRate />
      <IofDisplay />
      <SelectedInstalmentDisplay />
      <TotalAmountOverride />
    </ContextProvider>
  );
}
